document.addEventListener('click', function(event) {
    if (!event.target.matches('#checkout_need_invoice')) return;
    event.target.closest('.section__content').classList[ event.target.checked ? 'add' : 'remove'] ('selected');
    if (!document.getElementById('invoice-section').classList.contains('selected')) {
      document.getElementById("invoice_azienda").checked = false;
      document.getElementById("invoice_privato").checked = false;
      document.getElementById("invoice_privato_non_italian").checked = false;
      document.getElementById("invoice_azienda_non_italian").checked = false;
      if (document.querySelector('.invoice_azienda-box') ) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_azienda-box'));
      } else if (document.querySelector('.invoice_privato-box') ) {
        document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_privato-box'));
      } else if (document.querySelector('.invoice_privato-non-italian-box') ) {
        document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_privato-non-italian-box'));
      } else if (document.querySelector('.invoice_azienda-non-italian-box') ) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_azienda-non-italian-box'));
      }
    } else {  
      if (document.querySelector('.not-selected_invoice')) {
        document.querySelector('.type-of-invoice').classList.remove('error');
        document.querySelector('.not-selected_invoice').classList.add('hidden');
      } 
    }
  }, false);

  function forceInputUppercase (e) {
    let el = e.target;
    let start = el.selectionStart;
    let end = el.selectionEnd;
    el.value = el.value.toUpperCase();
    el.setSelectionRange(start, end);
  };

  const invoiceTypes = document.querySelectorAll('[data-invoice-type]');
  invoiceTypes.forEach(element => {
    element.addEventListener('change', function() {
      const currentSelected = element.getAttribute('data-invoice-type');
      document.querySelector('.choice-invoice-type').classList.remove('invoice-azienda', 'invoice-privato', 'invoice_azienda-non-italian-box', 'invoice-privato-non-italian')
      document.querySelector('.choice-invoice-type').classList.add(currentSelected);
      if (element.id === 'invoice_azienda') {
        if (document.querySelector('.not-selected_invoice')) {
          document.querySelector('.type-of-invoice').classList.remove('error');
          document.querySelector('.not-selected_invoice').classList.add('hidden');
        }
        if (document.querySelector('.invoice_privato-box') ) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_privato-box'));
        } else if (document.querySelector('.invoice_azienda-non-italian-box')) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_azienda-non-italian-box'));
        } else if (document.querySelector('.invoice_privato-non-italian-box')) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_privato-non-italian-box'));
        }
        document.querySelector('.type-of-invoice').insertAdjacentHTML('afterend', `
          <div class="radio-group__row content-box__row content-box__row--secondary invoice_azienda-box">
            <div class="fieldset">
              <div class="invoice-fields">
                <div data-autocomplete-field-container="true" class="field field--required field--show-floating-label">
                    <div class="field__input-wrapper float-container">
                        <label class="field__label field__label--visible" for="invoice_regione_sociale">${window.theme.invoice.company_name}</label>
                        <input 
                          autocomplete="off" 
                          autocorrect="off" 
                          aria-expanded="false" 
                          class="field__input float-container__input" 
                          size="30" 
                          type="text" 
                          value="" 
                          maxlength="40"
                          aria-haspopup="false" 
                          id="invoice_regione_sociale" 
                          name="attributes[fe-azienda]">
                    </div>
                </div>
              </div>
              <div class="invoice-fields">
                <div data-autocomplete-field-container="true" class="field field--required field--show-floating-label">
                    <div class="field__input-wrapper float-container vat-wrapper">
                        <label class="field__label field__label--visible" for="invoice_partita-iva">${window.theme.invoice.vat_number}</label>
                        <input
                          autocomplete="off" 
                          autocorrect="off" 
                          aria-expanded="false" 
                          class="field__input capital float-container__input" 
                          size="30" 
                          type="text" 
                          value=""
                          maxlength="13" 
                          aria-haspopup="false"  
                          id="invoice_partita-iva" 
                          name="attributes[fe-piva]">
                    </div>
                </div>
              </div>
              <div class="invoice-fields">
                <div data-autocomplete-field-container="true" class="field field--required field--show-floating-label">
                    <div class="field__input-wrapper float-container">
                        <label class="field__label field__label--visible" for="invoice_sdi">${window.theme.invoice.sdi_code}</label>
                        <input
                          autocomplete="off" 
                          autocorrect="off" 
                          aria-expanded="false" 
                          class="field__input capital float-container__input" 
                          size="30" 
                          type="text" 
                          value="" 
                          maxlength="7"
                          aria-haspopup="false" 
                          id="invoice_sdi" 
                          name="attributes[fe-sdi]">
                    </div>
                </div>
              </div>
              <div class="invoice-fields">
                <div data-autocomplete-field-container="true" class="field field--required field--show-floating-label">
                    <div class="field__input-wrapper float-container">
                        <label class="field__label field__label--visible" for="invoice_pec">${window.theme.invoice.pec}</label>
                        <input 
                        autocomplete="off" 
                        autocorrect="off" 
                        aria-expanded="false" 
                        class="field__input float-container__input" 
                        size="30" 
                        type="email" 
                        value="" 
                        aria-haspopup="false" 
                        id="invoice_pec" 
                        name="attributes[fe-pec]">
                    </div>
                </div>
              </div>
            </div>
          </div>
        `);
        FloatLabel.init();
        document.querySelectorAll(".capital").forEach(function(current) {
          current.addEventListener("keyup", forceInputUppercase);
        });
        document.querySelector('.vat-wrapper').addEventListener('focusout', function() {
          let italianVat = document.getElementById('invoice_partita-iva');
          const pattern = /^[a-zA-Z]{2}/;
          const prefixIT = "IT";
          if (italianVat.value.length != 0) {
            if (!pattern.test(italianVat.value)) {
              const prefixedValue = prefixIT + italianVat.value;
              italianVat.value = prefixedValue;
            }
          }
        });
      };
      if (element.id === 'invoice_privato') {
        if (document.querySelector('.not-selected_invoice')) {
          document.querySelector('.type-of-invoice').classList.remove('error');
          document.querySelector('.not-selected_invoice').classList.add('hidden');
        }
        if (document.querySelector('.invoice_azienda-box') ) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_azienda-box'));
        } else if (document.querySelector('.invoice_azienda-non-italian-box')) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_azienda-non-italian-box'));
        } else if (document.querySelector('.invoice_privato-non-italian-box')) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_privato-non-italian-box'));
        }
        document.querySelector('.type-of-invoice').insertAdjacentHTML('afterend', `
          <div class="radio-group__row content-box__row content-box__row--secondary invoice_privato-box">
            <div class="fieldset">
                <div class="field field--required field--show-floating-label">
                    <div class="field__input-wrapper float-container">
                        <label class="field__label field__label--visible" for="checkout_codice_fiscale">${window.theme.invoice.fiscal_code}</label>
                        <input
                        autocomplete="off" 
                        autocorrect="off" 
                        aria-expanded="false" 
                        data-backup="codice_fiscale" 
                        class="field__input capital float-container__input" 
                        size="30" 
                        type="text" 
                        value="" 
                        name="attributes[fe-codice-fiscale]" 
                        data-country="IT"
                        id="checkout_codice_fiscale" aria-haspopup="false">
                    </div>
                </div>
            </div>
          </div>
        `);
        FloatLabel.init();
        document.querySelectorAll(".capital").forEach(function(current) {
          current.addEventListener("keyup", forceInputUppercase);
        });
      };
      if (element.id === 'invoice_azienda_non_italian') {
        if (document.querySelector('.not-selected_invoice')) {
          document.querySelector('.type-of-invoice').classList.remove('error');
          document.querySelector('.not-selected_invoice').classList.add('hidden');
        }
        if (document.querySelector('.invoice_privato-box') ) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_privato-box'));
        } else if (document.querySelector('.invoice_azienda-box')) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_azienda-box'));
        } else if (document.querySelector('.invoice_privato-non-italian-box')) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_privato-non-italian-box'));
        }
        document.querySelector('.type-of-invoice').insertAdjacentHTML('afterend', `
          <div class="radio-group__row content-box__row content-box__row--secondary invoice_azienda-non-italian-box">
            <div class="fieldset">
              <div class="invoice-fields">
                <div data-autocomplete-field-container="true" class="field field--required field--show-floating-label">
                    <div class="field__input-wrapper float-container">
                        <label class="field__label field__label--visible" for="invoice_regione_sociale">${window.theme.invoice.company_name}</label>
                        <input
                          autocomplete="off" 
                          autocorrect="off" 
                          aria-expanded="false" 
                          class="field__input float-container__input" 
                          size="30" 
                          type="text" 
                          value="" 
                          maxlength="40"
                          aria-haspopup="false" 
                          id="invoice_regione_sociale" 
                          name="attributes[fe-azienda]">
                    </div>
                </div>
              </div>
              <div class="invoice-fields">
                <div data-autocomplete-field-container="true" class="field field--required field--show-floating-label">
                    <div class="field__input-wrapper float-container">
                        <label class="field__label field__label--visible" for="invoice_partita-iva-non-italian">${window.theme.invoice.vat_number}</label>
                        <input
                          autocomplete="off" 
                          autocorrect="off" 
                          aria-expanded="false" 
                          class="field__input capital float-container__input" 
                          size="30" 
                          type="text" 
                          value="" 
                          aria-haspopup="false" 
                          id="invoice_partita-iva-non-italian" 
                          name="attributes[fe-piva]">
                    </div>
                </div>
              </div>
            </div>
          </div>
        `);
        FloatLabel.init();
        document.querySelectorAll(".capital").forEach(function(current) {
          current.addEventListener("keyup", forceInputUppercase);
        });
      };
      if (element.id === 'invoice_privato_non_italian') {
        if (document.querySelector('.not-selected_invoice')) {
          document.querySelector('.type-of-invoice').classList.remove('error');
          document.querySelector('.not-selected_invoice').classList.add('hidden');
        }
        if (document.querySelector('.invoice_privato-box') ) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_privato-box'));
        } else if (document.querySelector('.invoice_azienda-box')) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_azienda-box'));
        } else if (document.querySelector('.invoice_azienda-non-italian-box')) {
          document.querySelector('.choice-invoice-type').removeChild(document.querySelector('.invoice_azienda-non-italian-box'));
        }
        document.querySelector('.type-of-invoice').insertAdjacentHTML('afterend', `
          <div class="radio-group__row content-box__row content-box__row--secondary invoice_privato-non-italian-box">
            <div class="fieldset">
                <div class="field field--required field--show-floating-label">
                  <div class="field__input-wrapper field__input-wrapper__select float-container">
                      <label class="field__label field__label--visible" for="checkout_codice_fiscale_non_italian-country">${window.theme.invoice.fiscal_code_country}</label>
                      <select name="attributes[fe-codice-fiscale-paese]"  id="checkout_codice_fiscale_non_italian-country" 
                      autocomplete="off" 
                      autocorrect="off" 
                      aria-expanded="false" 
                      data-backup="codice_fiscale-country" 
                      class="field__input capital float-container__input">
                        <option selected style="display: none;" value=""></option>
                        <option value="AF">Afghanistan</option>
                        <option value="AL">Albania</option>
                        <option value="DZ">Algeria</option>
                        <option value="AS">American Samoa</option>
                        <option value="AD">Andorra</option>
                        <option value="AO">Angola</option>
                        <option value="AI">Anguilla</option>
                        <option value="AQ">Antarctica</option>
                        <option value="AG">Antigua and Barbuda</option>
                        <option value="AR">Argentina</option>
                        <option value="AM">Armenia</option>
                        <option value="AW">Aruba</option>
                        <option value="AU">Australia</option>
                        <option value="AT">Austria</option>
                        <option value="AZ">Azerbaijan</option>
                        <option value="BS">Bahamas</option>
                        <option value="BH">Bahrain</option>
                        <option value="BD">Bangladesh</option>
                        <option value="BB">Barbados</option>
                        <option value="BY">Belarus</option>
                        <option value="BE">Belgium</option>
                        <option value="BZ">Belize</option>
                        <option value="BJ">Benin</option>
                        <option value="BM">Bermuda</option>
                        <option value="BT">Bhutan</option>
                        <option value="BO">Bolivia</option>
                        <option value="BA">Bosnia and Herzegovina</option>
                        <option value="BW">Botswana</option>
                        <option value="BV">Bouvet Island</option>
                        <option value="BR">Brazil</option>
                        <option value="IO">British Indian Ocean Territory</option>
                        <option value="BN">Brunei Darussalam</option>
                        <option value="BG">Bulgaria</option>
                        <option value="BF">Burkina Faso</option>
                        <option value="BI">Burundi</option>
                        <option value="KH">Cambodia</option>
                        <option value="CM">Cameroon</option>
                        <option value="CA">Canada</option>
                        <option value="CV">Cape Verde</option>
                        <option value="KY">Cayman Islands</option>
                        <option value="CF">Central African Republic</option>
                        <option value="TD">Chad</option>
                        <option value="CL">Chile</option>
                        <option value="CN">China</option>
                        <option value="CX">Christmas Island</option>
                        <option value="CC">Cocos (Keeling) Islands</option>
                        <option value="CO">Colombia</option>
                        <option value="KM">Comoros</option>
                        <option value="CG">Congo</option>
                        <option value="CD">Congo (Democratic Republic)</option>
                        <option value="CK">Cook Islands</option>
                        <option value="CR">Costa Rica</option>
                        <option value="HR">Croatia</option>
                        <option value="CU">Cuba</option>
                        <option value="CY">Cyprus</option>
                        <option value="CZ">Czech Republic</option>
                        <option value="DK">Denmark</option>
                        <option value="DJ">Djibouti</option>
                        <option value="DM">Dominica</option>
                        <option value="DO">Dominican Republic</option>
                        <option value="TP">East Timor</option>
                        <option value="EC">Ecuador</option>
                        <option value="EG">Egypt</option>
                        <option value="SV">El Salvador</option>
                        <option value="GQ">Equatorial Guinea</option>
                        <option value="ER">Eritrea</option>
                        <option value="EE">Estonia</option>
                        <option value="ET">Ethiopia</option>
                        <option value="FK">Falkland Islands</option>
                        <option value="FO">Faroe Islands</option>
                        <option value="FJ">Fiji</option>
                        <option value="FI">Finland</option>
                        <option value="FR">France</option>
                        <option value="FX">France (European Territory)</option>
                        <option value="GF">French Guiana</option>
                        <option value="TF">French Southern Territories</option>
                        <option value="GA">Gabon</option>
                        <option value="GM">Gambia</option>
                        <option value="GE">Georgia</option>
                        <option value="DE">Germany</option>
                        <option value="GH">Ghana</option>
                        <option value="GI">Gibraltar</option>
                        <option value="GR">Greece</option>
                        <option value="GL">Greenland</option>
                        <option value="GD">Grenada</option>
                        <option value="GP">Guadeloupe</option>
                        <option value="GU">Guam</option>
                        <option value="GT">Guatemala</option>
                        <option value="GN">Guinea</option>
                        <option value="GW">Guinea Bissau</option>
                        <option value="GY">Guyana</option>
                        <option value="HT">Haiti</option>
                        <option value="HM">Heard and McDonald Islands</option>
                        <option value="VA">Holy See (Vatican)</option>
                        <option value="HN">Honduras</option>
                        <option value="HK">Hong Kong</option>
                        <option value="HU">Hungary</option>
                        <option value="IS">Iceland</option>
                        <option value="IN">India</option>
                        <option value="ID">Indonesia</option>
                        <option value="IR">Iran</option>
                        <option value="IQ">Iraq</option>
                        <option value="IE">Ireland</option>
                        <option value="IL">Israel</option>
                        <option value="CI">Cote D&rsquo;Ivoire</option>
                        <option value="JM">Jamaica</option>
                        <option value="JP">Japan</option>
                        <option value="JO">Jordan</option>
                        <option value="KZ">Kazakhstan</option>
                        <option value="KE">Kenya</option>
                        <option value="KI">Kiribati</option>
                        <option value="KW">Kuwait</option>
                        <option value="KG">Kyrgyzstan</option>
                        <option value="LA">Laos</option>
                        <option value="LV">Latvia</option>
                        <option value="LB">Lebanon</option>
                        <option value="LS">Lesotho</option>
                        <option value="LR">Liberia</option>
                        <option value="LY">Libya</option>
                        <option value="LI">Liechtenstein</option>
                        <option value="LT">Lithuania</option>
                        <option value="LU">Luxembourg</option>
                        <option value="MO">Macau</option>
                        <option value="MK">Macedonia</option>
                        <option value="MG">Madagascar</option>
                        <option value="MW">Malawi</option>
                        <option value="MY">Malaysia</option>
                        <option value="MV">Maldives</option>
                        <option value="ML">Mali</option>
                        <option value="MT">Malta</option>
                        <option value="MH">Marshall Islands</option>
                        <option value="MQ">Martinique</option>
                        <option value="MR">Mauritania</option>
                        <option value="MU">Mauritius</option>
                        <option value="YT">Mayotte</option>
                        <option value="MX">Mexico</option>
                        <option value="FM">Micronesia</option>
                        <option value="MD">Moldova</option>
                        <option value="MC">Monaco</option>
                        <option value="MN">Mongolia</option>
                        <option value="ME">Montenegro</option>
                        <option value="MS">Montserrat</option>
                        <option value="MA">Morocco</option>
                        <option value="MZ">Mozambique</option>
                        <option value="MM">Myanmar</option>
                        <option value="NA">Namibia</option>
                        <option value="NR">Nauru</option>
                        <option value="NP">Nepal</option>
                        <option value="NL">Netherlands</option>
                        <option value="AN">Netherlands Antilles</option>
                        <option value="NC">New Caledonia</option>
                        <option value="NZ">New Zealand</option>
                        <option value="NI">Nicaragua</option>
                        <option value="NE">Niger</option>
                        <option value="NG">Nigeria</option>
                        <option value="NU">Niue</option>
                        <option value="NF">Norfolk Island</option>
                        <option value="KP">North Korea</option>
                        <option value="MP">Northern Mariana Islands</option>
                        <option value="NO">Norway</option>
                        <option value="OM">Oman</option>
                        <option value="PK">Pakistan</option>
                        <option value="PW">Palau</option>
                        <option value="PS">Palestinian Territory</option>
                        <option value="PA">Panama</option>
                        <option value="PG">Papua New Guinea</option>
                        <option value="PY">Paraguay</option>
                        <option value="PE">Peru</option>
                        <option value="PH">Philippines</option>
                        <option value="PN">Pitcairn</option>
                        <option value="PL">Poland</option>
                        <option value="PF">Polynesia</option>
                        <option value="PT">Portugal</option>
                        <option value="PR">Puerto Rico</option>
                        <option value="QA">Qatar</option>
                        <option value="RE">Reunion</option>
                        <option value="RO">Romania</option>
                        <option value="RW">Rwanda</option>
                        <option value="GS">S. Georgia &amp; S. Sandwich Isls.</option>
                        <option value="SH">Saint Helena</option>
                        <option value="KN">Saint Kitts &amp; Nevis Anguilla</option>
                        <option value="LC">Saint Lucia</option>
                        <option value="PM">Saint Pierre and Miquelon</option>
                        <option value="VC">Saint Vincent &amp; Grenadines</option>
                        <option value="WS">Samoa</option>
                        <option value="SM">San Marino</option>
                        <option value="ST">Sao Tome and Principe</option>
                        <option value="SA">Saudi Arabia</option>
                        <option value="SN">Senegal</option>
                        <option value="RS">Serbia</option>
                        <option value="SC">Seychelles</option>
                        <option value="SL">Sierra Leone</option>
                        <option value="SG">Singapore</option>
                        <option value="SK">Slovakia</option>
                        <option value="SI">Slovenia</option>
                        <option value="SB">Solomon Islands</option>
                        <option value="SO">Somalia</option>
                        <option value="ZA">South Africa</option>
                        <option value="KR">South Korea</option>
                        <option value="ES">Spain</option>
                        <option value="LK">Sri Lanka</option>
                        <option value="SD">Sudan</option>
                        <option value="SR">Suriname</option>
                        <option value="SZ">Swaziland</option>
                        <option value="SE">Sweden</option>
                        <option value="CH">Switzerland</option>
                        <option value="SY">Syrian Arab Republic</option>
                        <option value="TW">Taiwan</option>
                        <option value="TJ">Tajikistan</option>
                        <option value="TZ">Tanzania</option>
                        <option value="TH">Thailand</option>
                        <option value="TG">Togo</option>
                        <option value="TK">Tokelau</option>
                        <option value="TO">Tonga</option>
                        <option value="TT">Trinidad and Tobago</option>
                        <option value="TN">Tunisia</option>
                        <option value="TR">Turkey</option>
                        <option value="TM">Turkmenistan</option>
                        <option value="TC">Turks and Caicos Islands</option>
                        <option value="TV">Tuvalu</option>
                        <option value="UG">Uganda</option>
                        <option value="UA">Ukraine</option>
                        <option value="AE">United Arab Emirates</option>
                        <option value="US">United States</option>
                        <option value="GB">United Kingdom</option>
                        <option value="UY">Uruguay</option>
                        <option value="UM">USA Minor Outlying Islands</option>
                        <option value="UZ">Uzbekistan</option>
                        <option value="VU">Vanuatu</option>
                        <option value="VE">Venezuela</option>
                        <option value="VN">Vietnam</option>
                        <option value="VG">Virgin Islands (British)</option>
                        <option value="VI">Virgin Islands (USA)</option>
                        <option value="WF">Wallis and Futuna Islands</option>
                        <option value="EH">Western Sahara</option>
                        <option value="YE">Yemen</option>
                        <option value="ZR">Zaire</option>
                        <option value="ZM">Zambia</option>
                        <option value="ZW">Zimbabwe</option>
                      </select>
                  </div>
                </div>
                <div class="field field--required field--show-floating-label">
                    <div class="field__input-wrapper float-container">
                        <label class="field__label field__label--visible" for="checkout_codice_fiscale_non_italian">${window.theme.invoice.fiscal_code}</label>
                        <input
                        autocomplete="off" 
                        autocorrect="off" 
                        aria-expanded="false" 
                        data-backup="codice_fiscale" 
                        class="field__input capital float-container__input" 
                        size="30" 
                        type="text" 
                        value="" 
                        name="attributes[fe-codice-fiscale]" 
                        id="checkout_codice_fiscale_non_italian" aria-haspopup="false">
                    </div>
                </div>
            </div>
          </div>
        `);
        FloatLabel.init();
        document.querySelectorAll(".capital").forEach(function(current) {
          current.addEventListener("keyup", forceInputUppercase);
        });
        let countrySelector = document.getElementById("checkout_codice_fiscale_non_italian-country");
        let fiscalCodeCountry = document.getElementById("checkout_codice_fiscale_non_italian");
        if (countrySelector) {
          countrySelector.addEventListener("change", function() {
            fiscalCodeCountry.setAttribute("data-country", countrySelector.value);
          });
        }
      };
    });
  })
  window.sintraElectronicInvoice = function () {
    var is_required = false;

    $('.radio-group__row input').on('input', function() {
      var c = this.selectionStart,
          r = /[^a-zA-Z0-9 .,@_-]/gi,
          v = $(this).val();
      if(r.test(v)) {
        $(this).val(v.replace(r, ''));
        c--;
      }
      this.setSelectionRange(c, c);
    });
    
    function init(a) {
      bindSubmitCart();
    }

    function bindSubmitCart() {
      var element = document.getElementById('cart_form');
      element.addEventListener("submit", checkRequiredInput, true);
    }

    function isFiscalCodeValid(value) { 
      let exp = '^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9]{2}([a-zA-Z]{1}[0-9]{3})[a-zA-Z]{1}$',
        re = new RegExp(exp);
      return re.test(value);
    }

    function isVatValid(value) {
      let exp = '^(IT)[0-9]{1,100}$',
        re = new RegExp(exp);
        if(re.test(value) && checkVAT(value, countries).isValid ){
          return true;
        }else{
          return false;
        }
    }

    function isVatValidNonItalian(value) {
      let exp = '^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9]*$',
        re = new RegExp(exp);
        if(checkVAT(value, countries).isValid){
          return true;
        }else{
          return false;
        }
    }

    function isPecValid(value) {
      let exp = '^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$',
        re = new RegExp(exp);
      return re.test(value);
    }

    function isSdiValid(value) {
      let exp = '^[a-zA-Z0-9]{7}$',
        re = new RegExp(exp);
      return re.test(value);
    }

    function isCigValid(value) {
      let exp = '^[a-z0-9]{10}$',
        re = new RegExp(exp);
      return re.test(value);
    }

    function isCupValid(value) {
      let exp = '^[a-z0-9]{15}$',
        re = new RegExp(exp);
      return re.test(value);
    }

    function validate() {
      let feRequest = document.getElementById('checkout_need_invoice'),
        feCustomerType = document.querySelector('#invoice-section input[name="checkout[attributes][fe-tipo-cliente]"]:checked');

      if (!feRequest.checked && !is_required) {
        return;
        if (document.querySelector('.not-selected_invoice')) {
          document.querySelector('.type-of-invoice').classList.remove('error');
          document.querySelector('.not-selected_invoice').classList.add('hidden');
        }
      }else if(!feRequest.checked && is_required){
        throw window.theme.invoice.required;
      }else if(feRequest.checked && feCustomerType == null){
        if (!document.querySelector('.not-selected_invoice')) {
          document.querySelector('.type-of-invoice').classList.add('error');
          document.querySelector('.type-of-invoice').insertAdjacentHTML('afterend', `
            <p class="field__message invoice-error not-selected_invoice">
              ${window.theme.invoice.select_invoice}
            </p>
          `);
        }
        if (document.querySelector('.not-selected_invoice').classList.contains('hidden')) {
          document.querySelector('.not-selected_invoice').classList.remove('hidden');
          document.querySelector('.type-of-invoice').classList.add('error');
        }
        throw window.theme.invoice.customer_type_required;
      }

      let fiscalCode = document.getElementById('checkout_codice_fiscale');
      let fiscalCodeNotItalianCounty = document.getElementById('checkout_codice_fiscale_non_italian-country');
      let fiscalCodeNotItalian = document.getElementById('checkout_codice_fiscale_non_italian');
      let company = document.getElementById('invoice_regione_sociale');
      let vat = document.getElementById('invoice_partita-iva');
      let vatNonItalian = document.getElementById('invoice_partita-iva-non-italian');
      let sdi = document.getElementById('invoice_sdi');
      let pec = document.getElementById('invoice_pec');

      function validationError(inputID, errorClass, errorText) {
        if (!document.querySelector(`.${errorClass}`)) {
          document.getElementById(`${inputID}`).classList.add('error');
          document.getElementById(`${inputID}`).insertAdjacentHTML('afterend', `
            <p class="field__message invoice-error ${errorClass}">
              ${errorText}
            </p>
          `);
        }
        if (document.querySelector(`.${errorClass}`).classList.contains('hidden')) {
          document.querySelector(`.${errorClass}`).classList.remove('hidden');
        }
        throw new Error();
      }

      function removeErrorMessage(inputID, errorClass) {
        document.getElementById(`${inputID}`).classList.remove('error');
        document.querySelector(`.${errorClass}`).classList.add('hidden');
      }

      switch (feCustomerType.value) {
        case 'private':
        if (fiscalCode) {
          if (fiscalCode.value.trim() === '') {
            validationError('checkout_codice_fiscale', 'fiscalCode-required', window.theme.invoice.fiscal_code_required);
          } else {
            if (document.querySelector('.fiscalCode-required')) {
              removeErrorMessage('checkout_codice_fiscale', 'fiscalCode-required');
            }
            if (!isFiscalCodeValid(fiscalCode.value)) {
              validationError('checkout_codice_fiscale', 'fiscalCode-error', window.theme.invoice.fiscal_code_error);
            } else if (document.querySelector('.fiscalCode-error')) {
              removeErrorMessage('checkout_codice_fiscale', 'fiscalCode-error');
            }
          }
        }
        break;

        case 'private-non-italian':
          if (fiscalCodeNotItalian) {
            if (fiscalCodeNotItalianCounty.value.trim() === '') {
              validationError('checkout_codice_fiscale_non_italian-country', 'fiscalCode-country_required', window.theme.invoice.fiscal_code_required_country);
            } else {
              if (document.querySelector('.fiscalCode-country_required')) {
                removeErrorMessage('checkout_codice_fiscale_non_italian-country', 'fiscalCode-country_required');
              }
            }

            if (fiscalCodeNotItalian.value.trim() === '') {
              validationError('checkout_codice_fiscale_non_italian', 'fiscalCode-required', window.theme.invoice.fiscal_code_required);
            } else {
              if (document.querySelector('.fiscalCode-required')) {
                removeErrorMessage('checkout_codice_fiscale_non_italian', 'fiscalCode-required');
              }
              if (!isFiscalCodeValid(fiscalCodeNotItalian.value)) {
                validationError('checkout_codice_fiscale_non_italian', 'fiscalCode-error', window.theme.invoice.fiscal_code_error);
              } else if (document.querySelector('.fiscalCode-error')) {
                removeErrorMessage('checkout_codice_fiscale_non_italian', 'fiscalCode-error');
              }
            }
          }
          break;

        case 'company':
        if (vat) {
          if (company.value.trim() === '') {
            validationError('invoice_regione_sociale', 'company-name__error', window.theme.invoice.company_required);
          } else if (document.querySelector('.company-name__error')) {
            removeErrorMessage('invoice_regione_sociale', 'company-name__error');
          }

          if (vat.value.trim() === '') {
            validationError('invoice_partita-iva', 'vat-required', window.theme.invoice.vat_required);
          } else {
            if (document.querySelector('.vat-required')) {
              removeErrorMessage('invoice_partita-iva', 'vat-required');
            }
            if (!isVatValid(vat.value)) {
              validationError('invoice_partita-iva', 'iva-error', window.theme.invoice.vat_error);
            } else if (document.querySelector('.iva-error')) {
              removeErrorMessage('invoice_partita-iva', 'iva-error');
            }
          }

          if (sdi.value.trim() === '') {
            validationError('invoice_sdi', 'sdi-required', window.theme.invoice.sdi_required);
          } else {
            if (document.querySelector('.sdi-required')) {
              removeErrorMessage('invoice_sdi', 'sdi-required');
            }
            if (!isSdiValid(sdi.value)) {
              validationError('invoice_sdi', 'sdi-error', window.theme.invoice.sdi_charcount);
            } else if (document.querySelector('.sdi-error')) {
              removeErrorMessage('invoice_sdi', 'sdi-error');
            }
          }

          if (pec.value.trim() === '') {
            validationError('invoice_pec', 'pec-required', window.theme.invoice.pec_required);
          } else {
            if (document.querySelector('.pec-required')) {
              removeErrorMessage('invoice_pec', 'pec-required');
            }
            if (!isPecValid(pec.value)) {
              validationError('invoice_pec', 'pec-error', window.theme.invoice.pec_error);
            } else if (document.querySelector('.pec-error')) {
              removeErrorMessage('invoice_pec', 'pec-error');
            }
          }         
        }

        case 'company-non-italian':
        if (vatNonItalian) {
          if (company.value.trim() === '') {
            validationError('invoice_regione_sociale', 'company-name__error', window.theme.invoice.company_required);
          } else if (document.querySelector('.company-name__error')) {
            removeErrorMessage('invoice_regione_sociale', 'company-name__error');
          }

          if (vatNonItalian.value.trim() === '') {
            validationError('invoice_partita-iva-non-italian', 'vat-required', window.theme.invoice.vat_required);
          } else {
            if (document.querySelector('.vat-required')) {
              removeErrorMessage('invoice_partita-iva-non-italian', 'vat-required');
            }
            if (!isVatValidNonItalian(vatNonItalian.value)) {
              validationError('invoice_partita-iva-non-italian', 'iva-non-italian-error', window.theme.invoice.vat_error);
            } else if (document.querySelector('.iva-non-italian-error')) {
              removeErrorMessage('invoice_partita-iva-non-italian', 'iva-non-italian-error');
            }
          }      
        }
        
        break;
      }

    };

    function checkRequiredInput(event) {
      try {
        validate();
      } catch (errorMessage) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    }

    return {
      init: init
    };
  };
  window.sintraElectronicInvoice().init();

  document.querySelector('#cart_form').addEventListener('submit', ()=>{
    if (document.querySelector('.type-of-invoice #invoice_privato').checked) {
      let privateInvoice = document.querySelector('.type-of-invoice #invoice_privato').value;
      let fiscalCode = document.getElementById('checkout_codice_fiscale').value;
      let fiscalCodeCountry = document.getElementById('checkout_codice_fiscale').getAttribute("data-country");
      sessionStorage.setItem('invoiceType', privateInvoice);
      sessionStorage.setItem('fiscalCode', fiscalCode);
      sessionStorage.setItem('fiscalCodeCountry', fiscalCodeCountry);
      if('companyName' in sessionStorage) {
        window.sessionStorage.removeItem('companyName');
      }
      if('vatNumber' in sessionStorage) {
        window.sessionStorage.removeItem('vatNumber');
      }
      if('sdiNumber' in sessionStorage) {
        window.sessionStorage.removeItem('sdiNumber');
      }
      if('PEC' in sessionStorage) {
        window.sessionStorage.removeItem('PEC');
      }
      if('vatNumberNonItalian' in sessionStorage) {
        window.sessionStorage.removeItem('vatNumberNonItalian');
      }
    } else if (document.querySelector('.type-of-invoice #invoice_azienda').checked) {
      let companyInvoice = document.querySelector('.type-of-invoice #invoice_azienda').value;
      let companyName = document.getElementById('invoice_regione_sociale').value;
      let vatNumber = document.getElementById('invoice_partita-iva').value;
      let sdiNumber = document.getElementById('invoice_sdi').value;
      let pec = document.getElementById('invoice_pec').value;
      sessionStorage.setItem('invoiceType', companyInvoice);
      sessionStorage.setItem('companyName', companyName);
      sessionStorage.setItem('vatNumber', vatNumber);
      sessionStorage.setItem('sdiNumber', sdiNumber);
      sessionStorage.setItem('PEC', pec);
      if('fiscalCode' in sessionStorage) {
        window.sessionStorage.removeItem('fiscalCode');
      }
      if('fiscalCodeCountry' in sessionStorage) {
        window.sessionStorage.removeItem('fiscalCodeCountry');
      }
      if('vatNumberNonItalian' in sessionStorage) {
        window.sessionStorage.removeItem('vatNumberNonItalian');
      }
    } else if (document.querySelector('.type-of-invoice #invoice_privato_non_italian').checked) {
      let privateInvoice = document.querySelector('.type-of-invoice #invoice_privato_non_italian').value;
      let fiscalCode = document.getElementById('checkout_codice_fiscale_non_italian').value;
      let fiscalCodeCountry = document.getElementById('checkout_codice_fiscale_non_italian').getAttribute("data-country");
      sessionStorage.setItem('invoiceType', privateInvoice);
      sessionStorage.setItem('fiscalCodeCountry', fiscalCodeCountry);
      sessionStorage.setItem('fiscalCode', fiscalCode);
      if('companyName' in sessionStorage) {
        window.sessionStorage.removeItem('companyName');
      }
      if('vatNumber' in sessionStorage) {
        window.sessionStorage.removeItem('vatNumber');
      }
      if('sdiNumber' in sessionStorage) {
        window.sessionStorage.removeItem('sdiNumber');
      }
      if('PEC' in sessionStorage) {
        window.sessionStorage.removeItem('PEC');
      }
      if('vatNumberNonItalian' in sessionStorage) {
        window.sessionStorage.removeItem('vatNumberNonItalian');
      }
    } else if (document.querySelector('.type-of-invoice #invoice_azienda_non_italian').checked) {
      let companyNonItalianInvoice = document.querySelector('.type-of-invoice #invoice_azienda_non_italian').value;
      let companyName = document.getElementById('invoice_regione_sociale').value;
      let vatNumberNonItalian = document.getElementById('invoice_partita-iva-non-italian').value;
      sessionStorage.setItem('invoiceType', companyNonItalianInvoice);
      sessionStorage.setItem('companyName', companyName);
      sessionStorage.setItem('vatNumberNonItalian', vatNumberNonItalian);
      if('fiscalCode' in sessionStorage) {
        window.sessionStorage.removeItem('fiscalCode');
      }
      if('fiscalCodeCountry' in sessionStorage) {
        window.sessionStorage.removeItem('fiscalCodeCountry');
      }
      if('vatNumber' in sessionStorage) {
        window.sessionStorage.removeItem('vatNumber');
      }
      if('sdiNumber' in sessionStorage) {
        window.sessionStorage.removeItem('sdiNumber');
      }
      if('PEC' in sessionStorage) {
        window.sessionStorage.removeItem('PEC');
      }
    }
  });